import { useEffect, useState } from 'react';

export function usePersistedChecklist<T extends { id: string | number; checked: boolean }>(
    storageKey: string,
    initialItems: T[]
) {
    const [items, setItems] = useState<T[]>(() => {
        try {
            const stored = localStorage.getItem(storageKey);
            if (stored) {
                return JSON.parse(stored) as T[];
            }
        } catch (e) {
            console.warn(`Failed to read ${storageKey} from localStorage`, e);
        }

        // fallback → store defaults
        localStorage.setItem(storageKey, JSON.stringify(initialItems));
        return initialItems;
    });

    useEffect(() => {
        localStorage.setItem(storageKey, JSON.stringify(items));
    }, [items, storageKey]);

    return [items, setItems] as const;
}
